var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { selectBalancingOutskirt } from "../../../../../../balancingSelectors/selectBalancingOutskirts";
import { IdStyles } from "../../../../../../less/IdStyles";
import { actionBeginBuyWithGoldProcess } from "../../../../../buy-with-gold/actionBuyWithGold";
import { Icon } from "../../../../../generic/icon/Icon";
import { actionShowMeQuestTaskBuyImprovement } from "../../../../../show-me/actionShowMe";
import { ButtonQuestShowMe } from "../ButtonQuestShowMe";
import { QuestSkipButton } from "../QuestSkipButton";
import { QuestTask } from "../QuestTask";
var _QuestTaskBuyImprovement = function (props) {
    var className = props.className, tasks = props.tasks, questInfoTasks = props.questInfoTasks, quest = props.quest, onTrySkip = props.onTrySkip, onShowMe = props.onShowMe;
    var task = tasks;
    var list = task.map(function (value) {
        var outskirtBuildingInfo = selectBalancingOutskirt(value.outsideBuildingId);
        var requiredTaskInfo = questInfoTasks.find(function (val) { return val.index === value.index; });
        var currentAmount = requiredTaskInfo.amount || 0;
        var taskCompleted = currentAmount >= value.amount;
        var icon = React.createElement(Icon, { icon: quest.buttonIconRight, styleId: IdStyles.IconExtraLarge });
        var taskProps = {
            currentAmount: currentAmount,
            icon: icon,
            locaKey: value.locaKey,
            requiredAmount: value.amount,
            taskCompleted: taskCompleted,
        };
        var skipButtonProps = {
            currentAmount: currentAmount,
            onTrySkip: onTrySkip,
            questId: quest.id,
            requiredAmount: value.amount,
            skipCost: value.skipCost,
            taskCompleted: taskCompleted,
            taskIndex: value.index,
        };
        return (React.createElement(QuestTask, __assign({ key: value.locaKey + "_" + outskirtBuildingInfo.name }, taskProps),
            React.createElement(QuestSkipButton, __assign({}, skipButtonProps)),
            React.createElement(ButtonQuestShowMe, { onClick: function () { return onShowMe(value); }, questTask: value })));
    });
    return (React.createElement("div", { key: "buyImprovement", className: className }, list));
};
var mapDispatch = function (dispatch) {
    return bindActionCreators({
        onShowMe: actionShowMeQuestTaskBuyImprovement,
        onTrySkip: actionBeginBuyWithGoldProcess,
    }, dispatch);
};
export var QuestTaskBuyImprovement = connect(undefined, mapDispatch)(_QuestTaskBuyImprovement);



//////////////////
// WEBPACK FOOTER
// ./src/features/info/quest/list/tasks/questTaskBuyImprovement/QuestTaskBuyImprovement.tsx
// module id = 2668
// module chunks = 3